import { ref } from 'vue'
import { accountDirectory } from '@/constants/portalNames.js'

const isAccountPortal = ref(false)
const setIsAccountPortal = (routeName: string) => {
	isAccountPortal.value = !!(routeName?.indexOf(accountDirectory) === 0)
}

export { isAccountPortal, setIsAccountPortal }
